<template>
  <svg
    id="a"
    data-name="Ebene 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 220.5 400"
  >
    <path d="M0,0v311.9c0,1.2.4,2.3,1.1,3.1l69.8,83.2c.9,1.1,2.3,1.8,3.8,1.8h140.9c2.7,0,4.9-2.2,4.9-4.9V0H0Z" style="fill: red;" />
    <polygon points="166.1 266.6 166.1 302.3 130.4 302.3 130.4 338 94.7 338 94.7 302.3 59 302.3 59 266.6 94.7 266.6 94.7 230.9 130.4 230.9 130.4 266.6 166.1 266.6" style="fill: #fff;" />
  </svg>
</template>
